'use strict';

import {BaseElement} from "../interfaces/BaseElement";
import {changeLangToCurrent, getCurrentLang} from "./langSwitcher/langSwitcher";

export class StaticPrepayment {
	constructor(parent, data) {
		this.data = data;

		this.#createButton(parent);
	}

	#createButton(parent) {
		new BaseElement('button')
			.addClass('prepayment-button', 'customer-contact-now-btn', 'prepayment-btn', 'language-string', 'button')
			.setAttributes({'data-dictionary': 'Make Prepayment'})
			.innerHtml(changeLangToCurrent('Make Prepayment'))
			.event('click', this.#createPrepayment.bind(this))
			.appendTo(parent);
	}

	#createPrepayment(event) {
		event.stopPropagation();

		const staticPrepaymentRoot = new BaseElement()
			.addAttribute('id', 'staticPrepayment')
			.appendTo(document.body);

		new BaseElement()
			.addClass('curtain')
			.appendTo(staticPrepaymentRoot.DOMElement);

		console.log(this.data);

		const aptData = {
			aptModel: this.data.propType,
			aptType: this.data.modelName,
			bedrooms: this.data.roomNum,
			floor: this.data.floorNum,
			price: this.data.price2
		}

		const dictionary = {
			rentRequest: {
				en: "Reservation request",
				he: "שריון דירה"
			},
			aptType: {
				en: "apt. type",
				he: "דגם"
			},
			bedrooms: {
				en: "bedrooms",
				he: "חדרים"
			},
			floor: {
				en: "floor",
				he: "קומה"
			},
			subtitle_1: {
				en: "Thank you for choosing to rent an apartment.",
				he: "תודה שבחרתם לתפוס את הדירה בפרוייקט."
			},
			subtitle_2: {
				en: "In this short and simple process we will make an apartment reservation for you.",
				he: "בתהליך קצר ופשוט זה נתפוס לך את הדירה."
			},
			subtitle_3: {
				en: "Personal Details",
				he: "פרטים אישיים"
			},
			phase: {
				en: "Phase",
				he: "שלב"
			},
			firstName: {
				en: "First Name",
				he: "שם פרטי"
			},
			lastName: {
				en: "Last Name",
				he: "שם משפחה"
			},
			cantBeEmpty: {
				en: " can't be empty",
				he: " הוא שדה חובה"
			},
			pleaseProvideValid: {
				en: "Please provide a valid ",
				he: "Please provide a valid"
			},
			email: {
				en: "Email",
				he: "אימייל"
			},
			mobile: {
				en: "Mobile",
				he: "נייד"
			},
			startReservation: {
				en: "Start Reservation",
				he: "התחל הזמנה"
			}
		}

		const content = `
			<h1 class="title">
				${dictionary.rentRequest[getCurrentLang()]}
			</h1>
			<div class="card-body p-0">
			<div class="image-holder">
					<img src="https://dreamsimages.bmby.com/resize/image/width=600/AshtrumOlio/projectassets/gallery/E5D34704-3CC4-4862-8BC2-C0634CEE88B1/2.jpg" alt="House to reserve">
					<div class="apartment-data">
									<div class="apartment-data__item" data-type="price-and-type">
											<div class="first-line-price language-string">${changeLangToCurrent(aptData.aptModel)}</div>
											<div class="second-line-price">₪ ${aptData.price.toLocaleString()}</div>
									</div>
									<div class="apartment-data__separator"></div>
									<div class="apartment-data__item" data-type="model-name">
											<div class="first-line icon-plan-type">${aptData.aptType}</div>
											<div class="second-line language-string">
												${dictionary.aptType[getCurrentLang()]}
											</div>
									</div>
									<div class="apartment-data__separator"></div>
									<div class="apartment-data__item" data-type="bedrooms">
											<div class="first-line icon-bedroom">${aptData.bedrooms}</div>
											<div class="second-line language-string">
												${dictionary.bedrooms[getCurrentLang()]}
											</div>
									</div>
									<div class="apartment-data__separator"></div>
									
									<div class="apartment-data__item" data-type="bedrooms">
											<div class="first-line icon-floor">${aptData.floor}</div>
											<div class="second-line language-string">
												${dictionary.floor[getCurrentLang()]}
											</div>
									</div>
					</div>
			</div>
			<div class="changeable-data-holder float-direction">
					<div class="subtitle-1">
							<h2 class="text-direction">
								${dictionary.subtitle_1[getCurrentLang()]}
							</h2>
					</div>
					<div class="subtitle-2">
							<h2 class="text-direction">
							${dictionary.subtitle_2[getCurrentLang()]}	
							</h2>
					</div>
					<div class="subtitle-3 mt-30px">
							<div class="subtitle-header">
							${dictionary.subtitle_3[getCurrentLang()]}
							</div>
							<div class="stage">
									<span class="stage-span-green">1</span>
									<span class="stage-span-white">/4</span> 
									<span class="stage-span-white">
									${dictionary.phase[getCurrentLang()]}
									</span>
							</div>
					</div>
					<div class="form-row mt-30px">
							<label for="first_name" class="label-color label-direction mb-0 label-bmby">
							${dictionary.firstName[getCurrentLang()]}
							</label>
							<input type="text" class="form__field pt-0 pb-0" id="first_name" name="first_name" value="" required="">
							<div id="invalid_first_name" class="invalid-feedback" style="display: block; opacity: 0;">
									${dictionary.firstName[getCurrentLang()]}${dictionary.cantBeEmpty[getCurrentLang()]}
							</div>
					</div>
					<div class="form-row mt-10px">
							<label for="last_name" class="label-color label-direction mb-0 label-bmby">
							${dictionary.lastName[getCurrentLang()]}
							</label>
							<input type="text" class="form__field pt-0 pb-0" id="last_name" name="last_name" value="" required="">
							<div id="invalid_last_name" class="invalid-feedback" style="display: block; opacity: 0;">
									${dictionary.lastName[getCurrentLang()]}${dictionary.cantBeEmpty[getCurrentLang()]}
							</div>
					</div>
					<div class="form-row mt-10px">
							<label for="email" class="label-color label-direction mb-0 label-bmby">
							${dictionary.email[getCurrentLang()]}
							</label>
							<input type="text" class="form__field pt-0 pb-0" id="email" name="email" value="" required="">
							<div id="invalid_email" class="invalid-feedback" style="display: block; opacity: 0;">
									${dictionary.pleaseProvideValid[getCurrentLang()]}${dictionary.email[getCurrentLang()]}
							</div>
					</div>
					<div class="form-row mt-10px">
							<label for="phone" class="label-color label-direction mb-0 label-bmby">
							${dictionary.mobile[getCurrentLang()]}
							</label>
							<input type="text" class="form__field pt-0 pb-0" id="phone" name="phone" value="" required="">
							<div id="invalid_phone" class="invalid-feedback" style="display: block; opacity: 0;">
									${dictionary.pleaseProvideValid[getCurrentLang()]}${dictionary.mobile[getCurrentLang()]}
							</div>
					</div>
					<div class="form-row mt-10px dflex">
							<button type="button" id="button_1_stage" class="btn btn-stage position-unset">
							${dictionary.startReservation[getCurrentLang()]}
							</button>
					</div>
			</div>
	</div>
		`;
		new BaseElement()
			.addClass('content-element')
			.innerHtml(content)
			.appendTo(staticPrepaymentRoot.DOMElement);

		new BaseElement('button')
			.addClass('close-button', 'close-button-cross')
			.event('click', () => {
				staticPrepaymentRoot.remove()
			})
			.appendTo(staticPrepaymentRoot.DOMElement);
	}
}